import {
  APPENDAGE_CHAIN_PREFIXES,
  ARM_CHAIN_PREFIXES,
  FINGER_CHAIN_PREFIXES,
  LEG_CHAIN_PREFIXES,
} from '../lib/schema/navigation';

export const STANDARD_CHAIN_COLORS = {
  Spine: '#8c5cf5',
  Neck: '#05b5d4',
  Head: '#05b5d4',
  LeftArm: '#0fba82',
  RightArm: '#f59e0a',
  LeftFinger: '#06b6d4',
  RightFinger: '#ec4899',
  LeftClavicle: '#0fba82',
  RightClavicle: '#f59e0a',
  LeftLeg: '#3b82f5',
  RightLeg: '#f04545',
  LeftToe: '#3b82f5',
  RightToe: '#f04545',
  LeftHock: '#3b82f5',
  RightHock: '#f04545',
  Tail: '#8c5cf5',
  Tentacle: '#8c5cf5',
  Antennae: '#8c5cf5',
} as const;

export const DEFAULT_CHAIN_COLOR = '#b052de';

const CHAIN_COLOR_ENTRIES = Object.entries(STANDARD_CHAIN_COLORS);

function startsWithAny(value: string, prefixes: readonly string[]): boolean {
  return prefixes.some((prefix) => value === prefix || value.startsWith(prefix));
}

function isLeftSideChain(chainName: string): boolean {
  return chainName.startsWith('Left');
}

function isRightSideChain(chainName: string): boolean {
  return chainName.startsWith('Right');
}

export function getChainColor(chainName: string): string {
  for (const [prefix, color] of CHAIN_COLOR_ENTRIES) {
    if (chainName === prefix || chainName.startsWith(prefix)) return color;
  }

  if (startsWithAny(chainName, ARM_CHAIN_PREFIXES)) {
    return isLeftSideChain(chainName)
      ? STANDARD_CHAIN_COLORS.LeftArm
      : STANDARD_CHAIN_COLORS.RightArm;
  }

  if (startsWithAny(chainName, LEG_CHAIN_PREFIXES)) {
    return isLeftSideChain(chainName)
      ? STANDARD_CHAIN_COLORS.LeftLeg
      : STANDARD_CHAIN_COLORS.RightLeg;
  }

  if (startsWithAny(chainName, FINGER_CHAIN_PREFIXES)) {
    return isLeftSideChain(chainName)
      ? STANDARD_CHAIN_COLORS.LeftFinger
      : STANDARD_CHAIN_COLORS.RightFinger;
  }

  if (startsWithAny(chainName, APPENDAGE_CHAIN_PREFIXES)) {
    return STANDARD_CHAIN_COLORS.Tail;
  }

  if (isLeftSideChain(chainName)) return STANDARD_CHAIN_COLORS.LeftArm;
  if (isRightSideChain(chainName)) return STANDARD_CHAIN_COLORS.RightArm;

  return DEFAULT_CHAIN_COLOR;
}

export const getChainCssColor = getChainColor;
export function getChainThreeColor(chainName: string): number {
  const color = getChainColor(chainName);
  return Number.parseInt(color.replace('#', ''), 16);
}
